import { Card, Text } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractFormContext } from '../types';
import { Configuration } from './configuration';

interface Props {
  onShowAuthForm?: () => void;
  isAuthFormDisabled?: boolean;
}

export function Credentials(props: Props) {
  const { onShowAuthForm, isAuthFormDisabled } = props;

  const { watch } = useCarrierContractFormContext();
  const { t } = useTranslation();

  const schemaId = watch('schema_id');

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.credentials')}</Card.Header>
      <Card.Content>
        <Card.List>
          {schemaId ? (
            <Configuration
              isAuthFormDisabled={isAuthFormDisabled}
              onShowAuthForm={onShowAuthForm}
              schemaId={schemaId}
            />
          ) : (
            <Text variant="informative">{t('carrierContracts.details.credentialsEmpty')}</Text>
          )}
        </Card.List>
      </Card.Content>
    </Card.Wrapper>
  );
}
